import {
  ForgotPasswordPayload,
  ForgotPasswordResponse,
  GoogleSignupPayload,
  LoginPayload,
  LoginResponse,
  RegisterPayload,
  RegisterResponse,
  ResetPasswordPayload,
  ResetPasswordResponse,
  User,
} from 'types/auth';
import { api } from './instance';

export const login = async (payload: LoginPayload) => {
  const { data } = await api.post<LoginResponse>(`/auth/login`, payload);
  return data?.item;
};

export const googleLogin = async (payload: GoogleSignupPayload) => {
  const { data } = await api.post<LoginResponse>(`/auth/google-login`, payload);
  return data?.item;
};

export const register = async (payload: RegisterPayload) => {
  const { data } = await api.post<RegisterResponse>(`/auth/register`, payload);

  const loginResponse = await login({
    username: payload.email,
    password: payload.password,
  });

  const response: User = {
    ...data.item,
    tokens: loginResponse.tokens,
    profileId: loginResponse.profileId,
  };

  return response;
};

export const forgotPassword = async (payload: ForgotPasswordPayload) => {
  const { data } = await api.post<ForgotPasswordResponse>(
    `/users/forgot-password`,
    payload,
  );
  return data?.item;
};

export const resetPassword = async (payload: ResetPasswordPayload) => {
  const { data } = await api.post<ResetPasswordResponse>(
    `/auth/reset-password`,
    payload,
  );
  return data?.item;
};
